import { visitEventFlow } from './visitEventFlow';
import { visitEventFlowStep } from './visitEventFlowStep';
import { visitLayout } from './visitLayout';
import { visitPagelet } from './visitPagelet';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const builtinCollectDepsVisitors = [visitPagelet, visitLayout, visitEventFlow, visitEventFlowStep];
//# sourceMappingURL=index.js.map
